import { render, staticRenderFns } from "./updateTabs.vue?vue&type=template&id=fba30e00"
import script from "./updateTabs.vue?vue&type=script&lang=js"
export * from "./updateTabs.vue?vue&type=script&lang=js"
import style0 from "./updateTabs.vue?vue&type=style&index=0&id=fba30e00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports